/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as AuthAuthRouteImport } from './routes/auth/_auth'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthSignUpIndexRouteImport } from './routes/auth/sign-up/index'
import { Route as AuthAuthIndexRouteImport } from './routes/auth/_auth/index'
import { Route as AuthenticatedAccountIndexRouteImport } from './routes/_authenticated/account/index'
import { Route as AuthSignUpIdRouteImport } from './routes/auth/sign-up/$id'
import { Route as AuthenticatedLocationsShellRouteImport } from './routes/_authenticated/locations/_shell'
import { Route as AuthenticatedLocationsIdRouteImport } from './routes/_authenticated/locations/$id'
import { Route as AuthenticatedGetStartedGetStartedRouteImport } from './routes/_authenticated/get-started/_get-started'
import { Route as AuthenticatedAccountShellRouteImport } from './routes/_authenticated/account/_shell'
import { Route as AuthAuthVerifyEmailIndexRouteImport } from './routes/auth/_auth/verify-email/index'
import { Route as AuthAuthResetPasswordIndexRouteImport } from './routes/auth/_auth/reset-password/index'
import { Route as AuthAuthLoginIndexRouteImport } from './routes/auth/_auth/login/index'
import { Route as AuthAuthForgotPasswordIndexRouteImport } from './routes/auth/_auth/forgot-password/index'
import { Route as AuthenticatedLocationsAddIndexRouteImport } from './routes/_authenticated/locations/add/index'
import { Route as AuthenticatedLocationsShellIndexRouteImport } from './routes/_authenticated/locations/_shell/index'
import { Route as AuthenticatedLocationsIdShellRouteImport } from './routes/_authenticated/locations/$id/_shell'
import { Route as AuthenticatedAccountShellUsersRouteImport } from './routes/_authenticated/account/_shell/users'
import { Route as AuthenticatedAccountShellSecurityRouteImport } from './routes/_authenticated/account/_shell/security'
import { Route as AuthenticatedAccountShellProfileRouteImport } from './routes/_authenticated/account/_shell/profile'
import { Route as AuthenticatedAccountShellCompanyRouteImport } from './routes/_authenticated/account/_shell/company'
import { Route as AuthenticatedLocationsAddPromptsIndexRouteImport } from './routes/_authenticated/locations/add/prompts/index'
import { Route as AuthenticatedLocationsAddKeywordsIndexRouteImport } from './routes/_authenticated/locations/add/keywords/index'
import { Route as AuthenticatedGetStartedGetStartedUpdateBusinessDetailsIndexRouteImport } from './routes/_authenticated/get-started/_get-started/update-business-details/index'
import { Route as AuthenticatedGetStartedGetStartedGettingInsightsIndexRouteImport } from './routes/_authenticated/get-started/_get-started/getting-insights/index'
import { Route as AuthenticatedGetStartedGetStartedFindLocationIndexRouteImport } from './routes/_authenticated/get-started/_get-started/find-location/index'
import { Route as AuthenticatedGetStartedGetStartedAddPromptsIndexRouteImport } from './routes/_authenticated/get-started/_get-started/add-prompts/index'
import { Route as AuthenticatedGetStartedGetStartedAddKeywordsIndexRouteImport } from './routes/_authenticated/get-started/_get-started/add-keywords/index'
import { Route as AuthenticatedLocationsIdShellSummaryRouteImport } from './routes/_authenticated/locations/$id/_shell/summary'
import { Route as AuthenticatedLocationsIdShellLsgRouteImport } from './routes/_authenticated/locations/$id/_shell/lsg'
import { Route as AuthenticatedLocationsIdShellLrtRouteImport } from './routes/_authenticated/locations/$id/_shell/lrt'
import { Route as AuthenticatedLocationsIdShellLabsRouteImport } from './routes/_authenticated/locations/$id/_shell/labs'
import { Route as AuthenticatedLocationsIdShellAiVisibilityRouteImport } from './routes/_authenticated/locations/$id/_shell/ai-visibility'
import { Route as AuthenticatedLocationsIdShellLsgIndexRouteImport } from './routes/_authenticated/locations/$id/_shell/lsg/index'
import { Route as AuthenticatedLocationsIdShellLabsIndexRouteImport } from './routes/_authenticated/locations/$id/_shell/labs/index'
import { Route as AuthenticatedLocationsIdShellAiVisibilityIndexRouteImport } from './routes/_authenticated/locations/$id/_shell/ai-visibility/index'
import { Route as AuthenticatedLocationsIdShellReviewsTrackerRouteImport } from './routes/_authenticated/locations/$id/_shell/reviews/tracker'
import { Route as AuthenticatedLocationsIdShellReviewsManagerRouteImport } from './routes/_authenticated/locations/$id/_shell/reviews/manager'
import { Route as AuthenticatedLocationsIdShellLsgSettingsRouteImport } from './routes/_authenticated/locations/$id/_shell/lsg/settings'
import { Route as AuthenticatedLocationsIdShellLabsLabIdRouteImport } from './routes/_authenticated/locations/$id/_shell/labs/$labId'
import { Route as AuthenticatedLocationsIdShellGbpInsightsRouteImport } from './routes/_authenticated/locations/$id/_shell/gbp/insights'
import { Route as AuthenticatedLocationsIdShellReviewsManagerIndexRouteImport } from './routes/_authenticated/locations/$id/_shell/reviews/manager/index'
import { Route as AuthenticatedLocationsIdShellAiVisibilitySettingsIndexRouteImport } from './routes/_authenticated/locations/$id/_shell/ai-visibility/settings/index'
import { Route as AuthenticatedLocationsIdShellReviewsManagerTemplatesRouteImport } from './routes/_authenticated/locations/$id/_shell/reviews/manager/templates'
import { Route as AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRouteImport } from './routes/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit'
import { Route as AuthenticatedLocationsIdCbCampaignCampaignIdEditEditIndexRouteImport } from './routes/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit/index'
import { Route as AuthenticatedLocationsIdCbCampaignCampaignIdEditEditStepRouteImport } from './routes/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit/$step'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAuthRoute = AuthAuthRouteImport.update({
  id: '/auth/_auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthSignUpIndexRoute = AuthSignUpIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSignUpRoute,
} as any)
const AuthAuthIndexRoute = AuthAuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAuthRoute,
} as any)
const AuthenticatedAccountIndexRoute =
  AuthenticatedAccountIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthSignUpIdRoute = AuthSignUpIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthSignUpRoute,
} as any)
const AuthenticatedLocationsShellRoute =
  AuthenticatedLocationsShellRouteImport.update({
    id: '/locations/_shell',
    path: '/locations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLocationsIdRoute =
  AuthenticatedLocationsIdRouteImport.update({
    id: '/locations/$id',
    path: '/locations/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGetStartedGetStartedRoute =
  AuthenticatedGetStartedGetStartedRouteImport.update({
    id: '/get-started/_get-started',
    path: '/get-started',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountShellRoute =
  AuthenticatedAccountShellRouteImport.update({
    id: '/_shell',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthAuthVerifyEmailIndexRoute =
  AuthAuthVerifyEmailIndexRouteImport.update({
    id: '/verify-email/',
    path: '/verify-email/',
    getParentRoute: () => AuthAuthRoute,
  } as any)
const AuthAuthResetPasswordIndexRoute =
  AuthAuthResetPasswordIndexRouteImport.update({
    id: '/reset-password/',
    path: '/reset-password/',
    getParentRoute: () => AuthAuthRoute,
  } as any)
const AuthAuthLoginIndexRoute = AuthAuthLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AuthAuthRoute,
} as any)
const AuthAuthForgotPasswordIndexRoute =
  AuthAuthForgotPasswordIndexRouteImport.update({
    id: '/forgot-password/',
    path: '/forgot-password/',
    getParentRoute: () => AuthAuthRoute,
  } as any)
const AuthenticatedLocationsAddIndexRoute =
  AuthenticatedLocationsAddIndexRouteImport.update({
    id: '/locations/add/',
    path: '/locations/add/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLocationsShellIndexRoute =
  AuthenticatedLocationsShellIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLocationsShellRoute,
  } as any)
const AuthenticatedLocationsIdShellRoute =
  AuthenticatedLocationsIdShellRouteImport.update({
    id: '/_shell',
    getParentRoute: () => AuthenticatedLocationsIdRoute,
  } as any)
const AuthenticatedAccountShellUsersRoute =
  AuthenticatedAccountShellUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedAccountShellRoute,
  } as any)
const AuthenticatedAccountShellSecurityRoute =
  AuthenticatedAccountShellSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedAccountShellRoute,
  } as any)
const AuthenticatedAccountShellProfileRoute =
  AuthenticatedAccountShellProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedAccountShellRoute,
  } as any)
const AuthenticatedAccountShellCompanyRoute =
  AuthenticatedAccountShellCompanyRouteImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => AuthenticatedAccountShellRoute,
  } as any)
const AuthenticatedLocationsAddPromptsIndexRoute =
  AuthenticatedLocationsAddPromptsIndexRouteImport.update({
    id: '/locations/add/prompts/',
    path: '/locations/add/prompts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLocationsAddKeywordsIndexRoute =
  AuthenticatedLocationsAddKeywordsIndexRouteImport.update({
    id: '/locations/add/keywords/',
    path: '/locations/add/keywords/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGetStartedGetStartedUpdateBusinessDetailsIndexRoute =
  AuthenticatedGetStartedGetStartedUpdateBusinessDetailsIndexRouteImport.update(
    {
      id: '/update-business-details/',
      path: '/update-business-details/',
      getParentRoute: () => AuthenticatedGetStartedGetStartedRoute,
    } as any,
  )
const AuthenticatedGetStartedGetStartedGettingInsightsIndexRoute =
  AuthenticatedGetStartedGetStartedGettingInsightsIndexRouteImport.update({
    id: '/getting-insights/',
    path: '/getting-insights/',
    getParentRoute: () => AuthenticatedGetStartedGetStartedRoute,
  } as any)
const AuthenticatedGetStartedGetStartedFindLocationIndexRoute =
  AuthenticatedGetStartedGetStartedFindLocationIndexRouteImport.update({
    id: '/find-location/',
    path: '/find-location/',
    getParentRoute: () => AuthenticatedGetStartedGetStartedRoute,
  } as any)
const AuthenticatedGetStartedGetStartedAddPromptsIndexRoute =
  AuthenticatedGetStartedGetStartedAddPromptsIndexRouteImport.update({
    id: '/add-prompts/',
    path: '/add-prompts/',
    getParentRoute: () => AuthenticatedGetStartedGetStartedRoute,
  } as any)
const AuthenticatedGetStartedGetStartedAddKeywordsIndexRoute =
  AuthenticatedGetStartedGetStartedAddKeywordsIndexRouteImport.update({
    id: '/add-keywords/',
    path: '/add-keywords/',
    getParentRoute: () => AuthenticatedGetStartedGetStartedRoute,
  } as any)
const AuthenticatedLocationsIdShellSummaryRoute =
  AuthenticatedLocationsIdShellSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => AuthenticatedLocationsIdShellRoute,
  } as any)
const AuthenticatedLocationsIdShellLsgRoute =
  AuthenticatedLocationsIdShellLsgRouteImport.update({
    id: '/lsg',
    path: '/lsg',
    getParentRoute: () => AuthenticatedLocationsIdShellRoute,
  } as any)
const AuthenticatedLocationsIdShellLrtRoute =
  AuthenticatedLocationsIdShellLrtRouteImport.update({
    id: '/lrt',
    path: '/lrt',
    getParentRoute: () => AuthenticatedLocationsIdShellRoute,
  } as any)
const AuthenticatedLocationsIdShellLabsRoute =
  AuthenticatedLocationsIdShellLabsRouteImport.update({
    id: '/labs',
    path: '/labs',
    getParentRoute: () => AuthenticatedLocationsIdShellRoute,
  } as any)
const AuthenticatedLocationsIdShellAiVisibilityRoute =
  AuthenticatedLocationsIdShellAiVisibilityRouteImport.update({
    id: '/ai-visibility',
    path: '/ai-visibility',
    getParentRoute: () => AuthenticatedLocationsIdShellRoute,
  } as any)
const AuthenticatedLocationsIdShellLsgIndexRoute =
  AuthenticatedLocationsIdShellLsgIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLocationsIdShellLsgRoute,
  } as any)
const AuthenticatedLocationsIdShellLabsIndexRoute =
  AuthenticatedLocationsIdShellLabsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLocationsIdShellLabsRoute,
  } as any)
const AuthenticatedLocationsIdShellAiVisibilityIndexRoute =
  AuthenticatedLocationsIdShellAiVisibilityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLocationsIdShellAiVisibilityRoute,
  } as any)
const AuthenticatedLocationsIdShellReviewsTrackerRoute =
  AuthenticatedLocationsIdShellReviewsTrackerRouteImport.update({
    id: '/reviews/tracker',
    path: '/reviews/tracker',
    getParentRoute: () => AuthenticatedLocationsIdShellRoute,
  } as any)
const AuthenticatedLocationsIdShellReviewsManagerRoute =
  AuthenticatedLocationsIdShellReviewsManagerRouteImport.update({
    id: '/reviews/manager',
    path: '/reviews/manager',
    getParentRoute: () => AuthenticatedLocationsIdShellRoute,
  } as any)
const AuthenticatedLocationsIdShellLsgSettingsRoute =
  AuthenticatedLocationsIdShellLsgSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedLocationsIdShellLsgRoute,
  } as any)
const AuthenticatedLocationsIdShellLabsLabIdRoute =
  AuthenticatedLocationsIdShellLabsLabIdRouteImport.update({
    id: '/$labId',
    path: '/$labId',
    getParentRoute: () => AuthenticatedLocationsIdShellLabsRoute,
  } as any)
const AuthenticatedLocationsIdShellGbpInsightsRoute =
  AuthenticatedLocationsIdShellGbpInsightsRouteImport.update({
    id: '/gbp/insights',
    path: '/gbp/insights',
    getParentRoute: () => AuthenticatedLocationsIdShellRoute,
  } as any)
const AuthenticatedLocationsIdShellReviewsManagerIndexRoute =
  AuthenticatedLocationsIdShellReviewsManagerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLocationsIdShellReviewsManagerRoute,
  } as any)
const AuthenticatedLocationsIdShellAiVisibilitySettingsIndexRoute =
  AuthenticatedLocationsIdShellAiVisibilitySettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedLocationsIdShellAiVisibilityRoute,
  } as any)
const AuthenticatedLocationsIdShellReviewsManagerTemplatesRoute =
  AuthenticatedLocationsIdShellReviewsManagerTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AuthenticatedLocationsIdShellReviewsManagerRoute,
  } as any)
const AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRoute =
  AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRouteImport.update({
    id: '/cb/campaign/$campaignId/edit/_edit',
    path: '/cb/campaign/$campaignId/edit',
    getParentRoute: () => AuthenticatedLocationsIdRoute,
  } as any)
const AuthenticatedLocationsIdCbCampaignCampaignIdEditEditIndexRoute =
  AuthenticatedLocationsIdCbCampaignCampaignIdEditEditIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRoute,
  } as any)
const AuthenticatedLocationsIdCbCampaignCampaignIdEditEditStepRoute =
  AuthenticatedLocationsIdCbCampaignCampaignIdEditEditStepRouteImport.update({
    id: '/$step',
    path: '/$step',
    getParentRoute: () =>
      AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AuthenticatedAccountShellRouteWithChildren
  '/auth': typeof AuthAuthRouteWithChildren
  '/auth/sign-up': typeof AuthSignUpRouteWithChildren
  '/get-started': typeof AuthenticatedGetStartedGetStartedRouteWithChildren
  '/locations/$id': typeof AuthenticatedLocationsIdShellRouteWithChildren
  '/locations': typeof AuthenticatedLocationsShellRouteWithChildren
  '/auth/sign-up/$id': typeof AuthSignUpIdRoute
  '/account/': typeof AuthenticatedAccountIndexRoute
  '/auth/': typeof AuthAuthIndexRoute
  '/auth/sign-up/': typeof AuthSignUpIndexRoute
  '/account/company': typeof AuthenticatedAccountShellCompanyRoute
  '/account/profile': typeof AuthenticatedAccountShellProfileRoute
  '/account/security': typeof AuthenticatedAccountShellSecurityRoute
  '/account/users': typeof AuthenticatedAccountShellUsersRoute
  '/locations/': typeof AuthenticatedLocationsShellIndexRoute
  '/locations/add/': typeof AuthenticatedLocationsAddIndexRoute
  '/auth/forgot-password/': typeof AuthAuthForgotPasswordIndexRoute
  '/auth/login/': typeof AuthAuthLoginIndexRoute
  '/auth/reset-password/': typeof AuthAuthResetPasswordIndexRoute
  '/auth/verify-email/': typeof AuthAuthVerifyEmailIndexRoute
  '/locations/$id/ai-visibility': typeof AuthenticatedLocationsIdShellAiVisibilityRouteWithChildren
  '/locations/$id/labs': typeof AuthenticatedLocationsIdShellLabsRouteWithChildren
  '/locations/$id/lrt': typeof AuthenticatedLocationsIdShellLrtRoute
  '/locations/$id/lsg': typeof AuthenticatedLocationsIdShellLsgRouteWithChildren
  '/locations/$id/summary': typeof AuthenticatedLocationsIdShellSummaryRoute
  '/get-started/add-keywords/': typeof AuthenticatedGetStartedGetStartedAddKeywordsIndexRoute
  '/get-started/add-prompts/': typeof AuthenticatedGetStartedGetStartedAddPromptsIndexRoute
  '/get-started/find-location/': typeof AuthenticatedGetStartedGetStartedFindLocationIndexRoute
  '/get-started/getting-insights/': typeof AuthenticatedGetStartedGetStartedGettingInsightsIndexRoute
  '/get-started/update-business-details/': typeof AuthenticatedGetStartedGetStartedUpdateBusinessDetailsIndexRoute
  '/locations/add/keywords/': typeof AuthenticatedLocationsAddKeywordsIndexRoute
  '/locations/add/prompts/': typeof AuthenticatedLocationsAddPromptsIndexRoute
  '/locations/$id/gbp/insights': typeof AuthenticatedLocationsIdShellGbpInsightsRoute
  '/locations/$id/labs/$labId': typeof AuthenticatedLocationsIdShellLabsLabIdRoute
  '/locations/$id/lsg/settings': typeof AuthenticatedLocationsIdShellLsgSettingsRoute
  '/locations/$id/reviews/manager': typeof AuthenticatedLocationsIdShellReviewsManagerRouteWithChildren
  '/locations/$id/reviews/tracker': typeof AuthenticatedLocationsIdShellReviewsTrackerRoute
  '/locations/$id/ai-visibility/': typeof AuthenticatedLocationsIdShellAiVisibilityIndexRoute
  '/locations/$id/labs/': typeof AuthenticatedLocationsIdShellLabsIndexRoute
  '/locations/$id/lsg/': typeof AuthenticatedLocationsIdShellLsgIndexRoute
  '/locations/$id/reviews/manager/templates': typeof AuthenticatedLocationsIdShellReviewsManagerTemplatesRoute
  '/locations/$id/ai-visibility/settings/': typeof AuthenticatedLocationsIdShellAiVisibilitySettingsIndexRoute
  '/locations/$id/reviews/manager/': typeof AuthenticatedLocationsIdShellReviewsManagerIndexRoute
  '/locations/$id/cb/campaign/$campaignId/edit': typeof AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRouteWithChildren
  '/locations/$id/cb/campaign/$campaignId/edit/$step': typeof AuthenticatedLocationsIdCbCampaignCampaignIdEditEditStepRoute
  '/locations/$id/cb/campaign/$campaignId/edit/': typeof AuthenticatedLocationsIdCbCampaignCampaignIdEditEditIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AuthenticatedAccountIndexRoute
  '/get-started': typeof AuthenticatedGetStartedGetStartedRouteWithChildren
  '/locations/$id': typeof AuthenticatedLocationsIdShellRouteWithChildren
  '/auth/sign-up/$id': typeof AuthSignUpIdRoute
  '/auth': typeof AuthAuthIndexRoute
  '/auth/sign-up': typeof AuthSignUpIndexRoute
  '/account/company': typeof AuthenticatedAccountShellCompanyRoute
  '/account/profile': typeof AuthenticatedAccountShellProfileRoute
  '/account/security': typeof AuthenticatedAccountShellSecurityRoute
  '/account/users': typeof AuthenticatedAccountShellUsersRoute
  '/locations': typeof AuthenticatedLocationsShellIndexRoute
  '/locations/add': typeof AuthenticatedLocationsAddIndexRoute
  '/auth/forgot-password': typeof AuthAuthForgotPasswordIndexRoute
  '/auth/login': typeof AuthAuthLoginIndexRoute
  '/auth/reset-password': typeof AuthAuthResetPasswordIndexRoute
  '/auth/verify-email': typeof AuthAuthVerifyEmailIndexRoute
  '/locations/$id/lrt': typeof AuthenticatedLocationsIdShellLrtRoute
  '/locations/$id/summary': typeof AuthenticatedLocationsIdShellSummaryRoute
  '/get-started/add-keywords': typeof AuthenticatedGetStartedGetStartedAddKeywordsIndexRoute
  '/get-started/add-prompts': typeof AuthenticatedGetStartedGetStartedAddPromptsIndexRoute
  '/get-started/find-location': typeof AuthenticatedGetStartedGetStartedFindLocationIndexRoute
  '/get-started/getting-insights': typeof AuthenticatedGetStartedGetStartedGettingInsightsIndexRoute
  '/get-started/update-business-details': typeof AuthenticatedGetStartedGetStartedUpdateBusinessDetailsIndexRoute
  '/locations/add/keywords': typeof AuthenticatedLocationsAddKeywordsIndexRoute
  '/locations/add/prompts': typeof AuthenticatedLocationsAddPromptsIndexRoute
  '/locations/$id/gbp/insights': typeof AuthenticatedLocationsIdShellGbpInsightsRoute
  '/locations/$id/labs/$labId': typeof AuthenticatedLocationsIdShellLabsLabIdRoute
  '/locations/$id/lsg/settings': typeof AuthenticatedLocationsIdShellLsgSettingsRoute
  '/locations/$id/reviews/tracker': typeof AuthenticatedLocationsIdShellReviewsTrackerRoute
  '/locations/$id/ai-visibility': typeof AuthenticatedLocationsIdShellAiVisibilityIndexRoute
  '/locations/$id/labs': typeof AuthenticatedLocationsIdShellLabsIndexRoute
  '/locations/$id/lsg': typeof AuthenticatedLocationsIdShellLsgIndexRoute
  '/locations/$id/reviews/manager/templates': typeof AuthenticatedLocationsIdShellReviewsManagerTemplatesRoute
  '/locations/$id/ai-visibility/settings': typeof AuthenticatedLocationsIdShellAiVisibilitySettingsIndexRoute
  '/locations/$id/reviews/manager': typeof AuthenticatedLocationsIdShellReviewsManagerIndexRoute
  '/locations/$id/cb/campaign/$campaignId/edit/$step': typeof AuthenticatedLocationsIdCbCampaignCampaignIdEditEditStepRoute
  '/locations/$id/cb/campaign/$campaignId/edit': typeof AuthenticatedLocationsIdCbCampaignCampaignIdEditEditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/account': typeof AuthenticatedAccountRouteWithChildren
  '/auth/_auth': typeof AuthAuthRouteWithChildren
  '/auth/sign-up': typeof AuthSignUpRouteWithChildren
  '/_authenticated/account/_shell': typeof AuthenticatedAccountShellRouteWithChildren
  '/_authenticated/get-started/_get-started': typeof AuthenticatedGetStartedGetStartedRouteWithChildren
  '/_authenticated/locations/$id': typeof AuthenticatedLocationsIdRouteWithChildren
  '/_authenticated/locations/_shell': typeof AuthenticatedLocationsShellRouteWithChildren
  '/auth/sign-up/$id': typeof AuthSignUpIdRoute
  '/_authenticated/account/': typeof AuthenticatedAccountIndexRoute
  '/auth/_auth/': typeof AuthAuthIndexRoute
  '/auth/sign-up/': typeof AuthSignUpIndexRoute
  '/_authenticated/account/_shell/company': typeof AuthenticatedAccountShellCompanyRoute
  '/_authenticated/account/_shell/profile': typeof AuthenticatedAccountShellProfileRoute
  '/_authenticated/account/_shell/security': typeof AuthenticatedAccountShellSecurityRoute
  '/_authenticated/account/_shell/users': typeof AuthenticatedAccountShellUsersRoute
  '/_authenticated/locations/$id/_shell': typeof AuthenticatedLocationsIdShellRouteWithChildren
  '/_authenticated/locations/_shell/': typeof AuthenticatedLocationsShellIndexRoute
  '/_authenticated/locations/add/': typeof AuthenticatedLocationsAddIndexRoute
  '/auth/_auth/forgot-password/': typeof AuthAuthForgotPasswordIndexRoute
  '/auth/_auth/login/': typeof AuthAuthLoginIndexRoute
  '/auth/_auth/reset-password/': typeof AuthAuthResetPasswordIndexRoute
  '/auth/_auth/verify-email/': typeof AuthAuthVerifyEmailIndexRoute
  '/_authenticated/locations/$id/_shell/ai-visibility': typeof AuthenticatedLocationsIdShellAiVisibilityRouteWithChildren
  '/_authenticated/locations/$id/_shell/labs': typeof AuthenticatedLocationsIdShellLabsRouteWithChildren
  '/_authenticated/locations/$id/_shell/lrt': typeof AuthenticatedLocationsIdShellLrtRoute
  '/_authenticated/locations/$id/_shell/lsg': typeof AuthenticatedLocationsIdShellLsgRouteWithChildren
  '/_authenticated/locations/$id/_shell/summary': typeof AuthenticatedLocationsIdShellSummaryRoute
  '/_authenticated/get-started/_get-started/add-keywords/': typeof AuthenticatedGetStartedGetStartedAddKeywordsIndexRoute
  '/_authenticated/get-started/_get-started/add-prompts/': typeof AuthenticatedGetStartedGetStartedAddPromptsIndexRoute
  '/_authenticated/get-started/_get-started/find-location/': typeof AuthenticatedGetStartedGetStartedFindLocationIndexRoute
  '/_authenticated/get-started/_get-started/getting-insights/': typeof AuthenticatedGetStartedGetStartedGettingInsightsIndexRoute
  '/_authenticated/get-started/_get-started/update-business-details/': typeof AuthenticatedGetStartedGetStartedUpdateBusinessDetailsIndexRoute
  '/_authenticated/locations/add/keywords/': typeof AuthenticatedLocationsAddKeywordsIndexRoute
  '/_authenticated/locations/add/prompts/': typeof AuthenticatedLocationsAddPromptsIndexRoute
  '/_authenticated/locations/$id/_shell/gbp/insights': typeof AuthenticatedLocationsIdShellGbpInsightsRoute
  '/_authenticated/locations/$id/_shell/labs/$labId': typeof AuthenticatedLocationsIdShellLabsLabIdRoute
  '/_authenticated/locations/$id/_shell/lsg/settings': typeof AuthenticatedLocationsIdShellLsgSettingsRoute
  '/_authenticated/locations/$id/_shell/reviews/manager': typeof AuthenticatedLocationsIdShellReviewsManagerRouteWithChildren
  '/_authenticated/locations/$id/_shell/reviews/tracker': typeof AuthenticatedLocationsIdShellReviewsTrackerRoute
  '/_authenticated/locations/$id/_shell/ai-visibility/': typeof AuthenticatedLocationsIdShellAiVisibilityIndexRoute
  '/_authenticated/locations/$id/_shell/labs/': typeof AuthenticatedLocationsIdShellLabsIndexRoute
  '/_authenticated/locations/$id/_shell/lsg/': typeof AuthenticatedLocationsIdShellLsgIndexRoute
  '/_authenticated/locations/$id/_shell/reviews/manager/templates': typeof AuthenticatedLocationsIdShellReviewsManagerTemplatesRoute
  '/_authenticated/locations/$id/_shell/ai-visibility/settings/': typeof AuthenticatedLocationsIdShellAiVisibilitySettingsIndexRoute
  '/_authenticated/locations/$id/_shell/reviews/manager/': typeof AuthenticatedLocationsIdShellReviewsManagerIndexRoute
  '/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit': typeof AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRouteWithChildren
  '/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit/$step': typeof AuthenticatedLocationsIdCbCampaignCampaignIdEditEditStepRoute
  '/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit/': typeof AuthenticatedLocationsIdCbCampaignCampaignIdEditEditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/auth'
    | '/auth/sign-up'
    | '/get-started'
    | '/locations/$id'
    | '/locations'
    | '/auth/sign-up/$id'
    | '/account/'
    | '/auth/'
    | '/auth/sign-up/'
    | '/account/company'
    | '/account/profile'
    | '/account/security'
    | '/account/users'
    | '/locations/'
    | '/locations/add/'
    | '/auth/forgot-password/'
    | '/auth/login/'
    | '/auth/reset-password/'
    | '/auth/verify-email/'
    | '/locations/$id/ai-visibility'
    | '/locations/$id/labs'
    | '/locations/$id/lrt'
    | '/locations/$id/lsg'
    | '/locations/$id/summary'
    | '/get-started/add-keywords/'
    | '/get-started/add-prompts/'
    | '/get-started/find-location/'
    | '/get-started/getting-insights/'
    | '/get-started/update-business-details/'
    | '/locations/add/keywords/'
    | '/locations/add/prompts/'
    | '/locations/$id/gbp/insights'
    | '/locations/$id/labs/$labId'
    | '/locations/$id/lsg/settings'
    | '/locations/$id/reviews/manager'
    | '/locations/$id/reviews/tracker'
    | '/locations/$id/ai-visibility/'
    | '/locations/$id/labs/'
    | '/locations/$id/lsg/'
    | '/locations/$id/reviews/manager/templates'
    | '/locations/$id/ai-visibility/settings/'
    | '/locations/$id/reviews/manager/'
    | '/locations/$id/cb/campaign/$campaignId/edit'
    | '/locations/$id/cb/campaign/$campaignId/edit/$step'
    | '/locations/$id/cb/campaign/$campaignId/edit/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/get-started'
    | '/locations/$id'
    | '/auth/sign-up/$id'
    | '/auth'
    | '/auth/sign-up'
    | '/account/company'
    | '/account/profile'
    | '/account/security'
    | '/account/users'
    | '/locations'
    | '/locations/add'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/reset-password'
    | '/auth/verify-email'
    | '/locations/$id/lrt'
    | '/locations/$id/summary'
    | '/get-started/add-keywords'
    | '/get-started/add-prompts'
    | '/get-started/find-location'
    | '/get-started/getting-insights'
    | '/get-started/update-business-details'
    | '/locations/add/keywords'
    | '/locations/add/prompts'
    | '/locations/$id/gbp/insights'
    | '/locations/$id/labs/$labId'
    | '/locations/$id/lsg/settings'
    | '/locations/$id/reviews/tracker'
    | '/locations/$id/ai-visibility'
    | '/locations/$id/labs'
    | '/locations/$id/lsg'
    | '/locations/$id/reviews/manager/templates'
    | '/locations/$id/ai-visibility/settings'
    | '/locations/$id/reviews/manager'
    | '/locations/$id/cb/campaign/$campaignId/edit/$step'
    | '/locations/$id/cb/campaign/$campaignId/edit'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/account'
    | '/auth/_auth'
    | '/auth/sign-up'
    | '/_authenticated/account/_shell'
    | '/_authenticated/get-started/_get-started'
    | '/_authenticated/locations/$id'
    | '/_authenticated/locations/_shell'
    | '/auth/sign-up/$id'
    | '/_authenticated/account/'
    | '/auth/_auth/'
    | '/auth/sign-up/'
    | '/_authenticated/account/_shell/company'
    | '/_authenticated/account/_shell/profile'
    | '/_authenticated/account/_shell/security'
    | '/_authenticated/account/_shell/users'
    | '/_authenticated/locations/$id/_shell'
    | '/_authenticated/locations/_shell/'
    | '/_authenticated/locations/add/'
    | '/auth/_auth/forgot-password/'
    | '/auth/_auth/login/'
    | '/auth/_auth/reset-password/'
    | '/auth/_auth/verify-email/'
    | '/_authenticated/locations/$id/_shell/ai-visibility'
    | '/_authenticated/locations/$id/_shell/labs'
    | '/_authenticated/locations/$id/_shell/lrt'
    | '/_authenticated/locations/$id/_shell/lsg'
    | '/_authenticated/locations/$id/_shell/summary'
    | '/_authenticated/get-started/_get-started/add-keywords/'
    | '/_authenticated/get-started/_get-started/add-prompts/'
    | '/_authenticated/get-started/_get-started/find-location/'
    | '/_authenticated/get-started/_get-started/getting-insights/'
    | '/_authenticated/get-started/_get-started/update-business-details/'
    | '/_authenticated/locations/add/keywords/'
    | '/_authenticated/locations/add/prompts/'
    | '/_authenticated/locations/$id/_shell/gbp/insights'
    | '/_authenticated/locations/$id/_shell/labs/$labId'
    | '/_authenticated/locations/$id/_shell/lsg/settings'
    | '/_authenticated/locations/$id/_shell/reviews/manager'
    | '/_authenticated/locations/$id/_shell/reviews/tracker'
    | '/_authenticated/locations/$id/_shell/ai-visibility/'
    | '/_authenticated/locations/$id/_shell/labs/'
    | '/_authenticated/locations/$id/_shell/lsg/'
    | '/_authenticated/locations/$id/_shell/reviews/manager/templates'
    | '/_authenticated/locations/$id/_shell/ai-visibility/settings/'
    | '/_authenticated/locations/$id/_shell/reviews/manager/'
    | '/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit'
    | '/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit/$step'
    | '/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AuthAuthRoute: typeof AuthAuthRouteWithChildren
  AuthSignUpRoute: typeof AuthSignUpRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/_auth': {
      id: '/auth/_auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/auth/sign-up/': {
      id: '/auth/sign-up/'
      path: '/'
      fullPath: '/auth/sign-up/'
      preLoaderRoute: typeof AuthSignUpIndexRouteImport
      parentRoute: typeof AuthSignUpRoute
    }
    '/auth/_auth/': {
      id: '/auth/_auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthAuthIndexRouteImport
      parentRoute: typeof AuthAuthRoute
    }
    '/_authenticated/account/': {
      id: '/_authenticated/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AuthenticatedAccountIndexRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/auth/sign-up/$id': {
      id: '/auth/sign-up/$id'
      path: '/$id'
      fullPath: '/auth/sign-up/$id'
      preLoaderRoute: typeof AuthSignUpIdRouteImport
      parentRoute: typeof AuthSignUpRoute
    }
    '/_authenticated/locations/_shell': {
      id: '/_authenticated/locations/_shell'
      path: '/locations'
      fullPath: '/locations'
      preLoaderRoute: typeof AuthenticatedLocationsShellRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/locations/$id': {
      id: '/_authenticated/locations/$id'
      path: '/locations/$id'
      fullPath: '/locations/$id'
      preLoaderRoute: typeof AuthenticatedLocationsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/get-started/_get-started': {
      id: '/_authenticated/get-started/_get-started'
      path: '/get-started'
      fullPath: '/get-started'
      preLoaderRoute: typeof AuthenticatedGetStartedGetStartedRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/_shell': {
      id: '/_authenticated/account/_shell'
      path: ''
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountShellRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/auth/_auth/verify-email/': {
      id: '/auth/_auth/verify-email/'
      path: '/verify-email'
      fullPath: '/auth/verify-email/'
      preLoaderRoute: typeof AuthAuthVerifyEmailIndexRouteImport
      parentRoute: typeof AuthAuthRoute
    }
    '/auth/_auth/reset-password/': {
      id: '/auth/_auth/reset-password/'
      path: '/reset-password'
      fullPath: '/auth/reset-password/'
      preLoaderRoute: typeof AuthAuthResetPasswordIndexRouteImport
      parentRoute: typeof AuthAuthRoute
    }
    '/auth/_auth/login/': {
      id: '/auth/_auth/login/'
      path: '/login'
      fullPath: '/auth/login/'
      preLoaderRoute: typeof AuthAuthLoginIndexRouteImport
      parentRoute: typeof AuthAuthRoute
    }
    '/auth/_auth/forgot-password/': {
      id: '/auth/_auth/forgot-password/'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password/'
      preLoaderRoute: typeof AuthAuthForgotPasswordIndexRouteImport
      parentRoute: typeof AuthAuthRoute
    }
    '/_authenticated/locations/add/': {
      id: '/_authenticated/locations/add/'
      path: '/locations/add'
      fullPath: '/locations/add/'
      preLoaderRoute: typeof AuthenticatedLocationsAddIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/locations/_shell/': {
      id: '/_authenticated/locations/_shell/'
      path: '/'
      fullPath: '/locations/'
      preLoaderRoute: typeof AuthenticatedLocationsShellIndexRouteImport
      parentRoute: typeof AuthenticatedLocationsShellRoute
    }
    '/_authenticated/locations/$id/_shell': {
      id: '/_authenticated/locations/$id/_shell'
      path: ''
      fullPath: '/locations/$id'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellRouteImport
      parentRoute: typeof AuthenticatedLocationsIdRoute
    }
    '/_authenticated/account/_shell/users': {
      id: '/_authenticated/account/_shell/users'
      path: '/users'
      fullPath: '/account/users'
      preLoaderRoute: typeof AuthenticatedAccountShellUsersRouteImport
      parentRoute: typeof AuthenticatedAccountShellRoute
    }
    '/_authenticated/account/_shell/security': {
      id: '/_authenticated/account/_shell/security'
      path: '/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof AuthenticatedAccountShellSecurityRouteImport
      parentRoute: typeof AuthenticatedAccountShellRoute
    }
    '/_authenticated/account/_shell/profile': {
      id: '/_authenticated/account/_shell/profile'
      path: '/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AuthenticatedAccountShellProfileRouteImport
      parentRoute: typeof AuthenticatedAccountShellRoute
    }
    '/_authenticated/account/_shell/company': {
      id: '/_authenticated/account/_shell/company'
      path: '/company'
      fullPath: '/account/company'
      preLoaderRoute: typeof AuthenticatedAccountShellCompanyRouteImport
      parentRoute: typeof AuthenticatedAccountShellRoute
    }
    '/_authenticated/locations/add/prompts/': {
      id: '/_authenticated/locations/add/prompts/'
      path: '/locations/add/prompts'
      fullPath: '/locations/add/prompts/'
      preLoaderRoute: typeof AuthenticatedLocationsAddPromptsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/locations/add/keywords/': {
      id: '/_authenticated/locations/add/keywords/'
      path: '/locations/add/keywords'
      fullPath: '/locations/add/keywords/'
      preLoaderRoute: typeof AuthenticatedLocationsAddKeywordsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/get-started/_get-started/update-business-details/': {
      id: '/_authenticated/get-started/_get-started/update-business-details/'
      path: '/update-business-details'
      fullPath: '/get-started/update-business-details/'
      preLoaderRoute: typeof AuthenticatedGetStartedGetStartedUpdateBusinessDetailsIndexRouteImport
      parentRoute: typeof AuthenticatedGetStartedGetStartedRoute
    }
    '/_authenticated/get-started/_get-started/getting-insights/': {
      id: '/_authenticated/get-started/_get-started/getting-insights/'
      path: '/getting-insights'
      fullPath: '/get-started/getting-insights/'
      preLoaderRoute: typeof AuthenticatedGetStartedGetStartedGettingInsightsIndexRouteImport
      parentRoute: typeof AuthenticatedGetStartedGetStartedRoute
    }
    '/_authenticated/get-started/_get-started/find-location/': {
      id: '/_authenticated/get-started/_get-started/find-location/'
      path: '/find-location'
      fullPath: '/get-started/find-location/'
      preLoaderRoute: typeof AuthenticatedGetStartedGetStartedFindLocationIndexRouteImport
      parentRoute: typeof AuthenticatedGetStartedGetStartedRoute
    }
    '/_authenticated/get-started/_get-started/add-prompts/': {
      id: '/_authenticated/get-started/_get-started/add-prompts/'
      path: '/add-prompts'
      fullPath: '/get-started/add-prompts/'
      preLoaderRoute: typeof AuthenticatedGetStartedGetStartedAddPromptsIndexRouteImport
      parentRoute: typeof AuthenticatedGetStartedGetStartedRoute
    }
    '/_authenticated/get-started/_get-started/add-keywords/': {
      id: '/_authenticated/get-started/_get-started/add-keywords/'
      path: '/add-keywords'
      fullPath: '/get-started/add-keywords/'
      preLoaderRoute: typeof AuthenticatedGetStartedGetStartedAddKeywordsIndexRouteImport
      parentRoute: typeof AuthenticatedGetStartedGetStartedRoute
    }
    '/_authenticated/locations/$id/_shell/summary': {
      id: '/_authenticated/locations/$id/_shell/summary'
      path: '/summary'
      fullPath: '/locations/$id/summary'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellSummaryRouteImport
      parentRoute: typeof AuthenticatedLocationsIdShellRoute
    }
    '/_authenticated/locations/$id/_shell/lsg': {
      id: '/_authenticated/locations/$id/_shell/lsg'
      path: '/lsg'
      fullPath: '/locations/$id/lsg'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellLsgRouteImport
      parentRoute: typeof AuthenticatedLocationsIdShellRoute
    }
    '/_authenticated/locations/$id/_shell/lrt': {
      id: '/_authenticated/locations/$id/_shell/lrt'
      path: '/lrt'
      fullPath: '/locations/$id/lrt'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellLrtRouteImport
      parentRoute: typeof AuthenticatedLocationsIdShellRoute
    }
    '/_authenticated/locations/$id/_shell/labs': {
      id: '/_authenticated/locations/$id/_shell/labs'
      path: '/labs'
      fullPath: '/locations/$id/labs'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellLabsRouteImport
      parentRoute: typeof AuthenticatedLocationsIdShellRoute
    }
    '/_authenticated/locations/$id/_shell/ai-visibility': {
      id: '/_authenticated/locations/$id/_shell/ai-visibility'
      path: '/ai-visibility'
      fullPath: '/locations/$id/ai-visibility'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellAiVisibilityRouteImport
      parentRoute: typeof AuthenticatedLocationsIdShellRoute
    }
    '/_authenticated/locations/$id/_shell/lsg/': {
      id: '/_authenticated/locations/$id/_shell/lsg/'
      path: '/'
      fullPath: '/locations/$id/lsg/'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellLsgIndexRouteImport
      parentRoute: typeof AuthenticatedLocationsIdShellLsgRoute
    }
    '/_authenticated/locations/$id/_shell/labs/': {
      id: '/_authenticated/locations/$id/_shell/labs/'
      path: '/'
      fullPath: '/locations/$id/labs/'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellLabsIndexRouteImport
      parentRoute: typeof AuthenticatedLocationsIdShellLabsRoute
    }
    '/_authenticated/locations/$id/_shell/ai-visibility/': {
      id: '/_authenticated/locations/$id/_shell/ai-visibility/'
      path: '/'
      fullPath: '/locations/$id/ai-visibility/'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellAiVisibilityIndexRouteImport
      parentRoute: typeof AuthenticatedLocationsIdShellAiVisibilityRoute
    }
    '/_authenticated/locations/$id/_shell/reviews/tracker': {
      id: '/_authenticated/locations/$id/_shell/reviews/tracker'
      path: '/reviews/tracker'
      fullPath: '/locations/$id/reviews/tracker'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellReviewsTrackerRouteImport
      parentRoute: typeof AuthenticatedLocationsIdShellRoute
    }
    '/_authenticated/locations/$id/_shell/reviews/manager': {
      id: '/_authenticated/locations/$id/_shell/reviews/manager'
      path: '/reviews/manager'
      fullPath: '/locations/$id/reviews/manager'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellReviewsManagerRouteImport
      parentRoute: typeof AuthenticatedLocationsIdShellRoute
    }
    '/_authenticated/locations/$id/_shell/lsg/settings': {
      id: '/_authenticated/locations/$id/_shell/lsg/settings'
      path: '/settings'
      fullPath: '/locations/$id/lsg/settings'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellLsgSettingsRouteImport
      parentRoute: typeof AuthenticatedLocationsIdShellLsgRoute
    }
    '/_authenticated/locations/$id/_shell/labs/$labId': {
      id: '/_authenticated/locations/$id/_shell/labs/$labId'
      path: '/$labId'
      fullPath: '/locations/$id/labs/$labId'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellLabsLabIdRouteImport
      parentRoute: typeof AuthenticatedLocationsIdShellLabsRoute
    }
    '/_authenticated/locations/$id/_shell/gbp/insights': {
      id: '/_authenticated/locations/$id/_shell/gbp/insights'
      path: '/gbp/insights'
      fullPath: '/locations/$id/gbp/insights'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellGbpInsightsRouteImport
      parentRoute: typeof AuthenticatedLocationsIdShellRoute
    }
    '/_authenticated/locations/$id/_shell/reviews/manager/': {
      id: '/_authenticated/locations/$id/_shell/reviews/manager/'
      path: '/'
      fullPath: '/locations/$id/reviews/manager/'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellReviewsManagerIndexRouteImport
      parentRoute: typeof AuthenticatedLocationsIdShellReviewsManagerRoute
    }
    '/_authenticated/locations/$id/_shell/ai-visibility/settings/': {
      id: '/_authenticated/locations/$id/_shell/ai-visibility/settings/'
      path: '/settings'
      fullPath: '/locations/$id/ai-visibility/settings/'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellAiVisibilitySettingsIndexRouteImport
      parentRoute: typeof AuthenticatedLocationsIdShellAiVisibilityRoute
    }
    '/_authenticated/locations/$id/_shell/reviews/manager/templates': {
      id: '/_authenticated/locations/$id/_shell/reviews/manager/templates'
      path: '/templates'
      fullPath: '/locations/$id/reviews/manager/templates'
      preLoaderRoute: typeof AuthenticatedLocationsIdShellReviewsManagerTemplatesRouteImport
      parentRoute: typeof AuthenticatedLocationsIdShellReviewsManagerRoute
    }
    '/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit': {
      id: '/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit'
      path: '/cb/campaign/$campaignId/edit'
      fullPath: '/locations/$id/cb/campaign/$campaignId/edit'
      preLoaderRoute: typeof AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRouteImport
      parentRoute: typeof AuthenticatedLocationsIdRoute
    }
    '/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit/': {
      id: '/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit/'
      path: '/'
      fullPath: '/locations/$id/cb/campaign/$campaignId/edit/'
      preLoaderRoute: typeof AuthenticatedLocationsIdCbCampaignCampaignIdEditEditIndexRouteImport
      parentRoute: typeof AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRoute
    }
    '/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit/$step': {
      id: '/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit/$step'
      path: '/$step'
      fullPath: '/locations/$id/cb/campaign/$campaignId/edit/$step'
      preLoaderRoute: typeof AuthenticatedLocationsIdCbCampaignCampaignIdEditEditStepRouteImport
      parentRoute: typeof AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRoute
    }
  }
}

interface AuthenticatedAccountShellRouteChildren {
  AuthenticatedAccountShellCompanyRoute: typeof AuthenticatedAccountShellCompanyRoute
  AuthenticatedAccountShellProfileRoute: typeof AuthenticatedAccountShellProfileRoute
  AuthenticatedAccountShellSecurityRoute: typeof AuthenticatedAccountShellSecurityRoute
  AuthenticatedAccountShellUsersRoute: typeof AuthenticatedAccountShellUsersRoute
}

const AuthenticatedAccountShellRouteChildren: AuthenticatedAccountShellRouteChildren =
  {
    AuthenticatedAccountShellCompanyRoute:
      AuthenticatedAccountShellCompanyRoute,
    AuthenticatedAccountShellProfileRoute:
      AuthenticatedAccountShellProfileRoute,
    AuthenticatedAccountShellSecurityRoute:
      AuthenticatedAccountShellSecurityRoute,
    AuthenticatedAccountShellUsersRoute: AuthenticatedAccountShellUsersRoute,
  }

const AuthenticatedAccountShellRouteWithChildren =
  AuthenticatedAccountShellRoute._addFileChildren(
    AuthenticatedAccountShellRouteChildren,
  )

interface AuthenticatedAccountRouteChildren {
  AuthenticatedAccountShellRoute: typeof AuthenticatedAccountShellRouteWithChildren
  AuthenticatedAccountIndexRoute: typeof AuthenticatedAccountIndexRoute
}

const AuthenticatedAccountRouteChildren: AuthenticatedAccountRouteChildren = {
  AuthenticatedAccountShellRoute: AuthenticatedAccountShellRouteWithChildren,
  AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute,
}

const AuthenticatedAccountRouteWithChildren =
  AuthenticatedAccountRoute._addFileChildren(AuthenticatedAccountRouteChildren)

interface AuthenticatedGetStartedGetStartedRouteChildren {
  AuthenticatedGetStartedGetStartedAddKeywordsIndexRoute: typeof AuthenticatedGetStartedGetStartedAddKeywordsIndexRoute
  AuthenticatedGetStartedGetStartedAddPromptsIndexRoute: typeof AuthenticatedGetStartedGetStartedAddPromptsIndexRoute
  AuthenticatedGetStartedGetStartedFindLocationIndexRoute: typeof AuthenticatedGetStartedGetStartedFindLocationIndexRoute
  AuthenticatedGetStartedGetStartedGettingInsightsIndexRoute: typeof AuthenticatedGetStartedGetStartedGettingInsightsIndexRoute
  AuthenticatedGetStartedGetStartedUpdateBusinessDetailsIndexRoute: typeof AuthenticatedGetStartedGetStartedUpdateBusinessDetailsIndexRoute
}

const AuthenticatedGetStartedGetStartedRouteChildren: AuthenticatedGetStartedGetStartedRouteChildren =
  {
    AuthenticatedGetStartedGetStartedAddKeywordsIndexRoute:
      AuthenticatedGetStartedGetStartedAddKeywordsIndexRoute,
    AuthenticatedGetStartedGetStartedAddPromptsIndexRoute:
      AuthenticatedGetStartedGetStartedAddPromptsIndexRoute,
    AuthenticatedGetStartedGetStartedFindLocationIndexRoute:
      AuthenticatedGetStartedGetStartedFindLocationIndexRoute,
    AuthenticatedGetStartedGetStartedGettingInsightsIndexRoute:
      AuthenticatedGetStartedGetStartedGettingInsightsIndexRoute,
    AuthenticatedGetStartedGetStartedUpdateBusinessDetailsIndexRoute:
      AuthenticatedGetStartedGetStartedUpdateBusinessDetailsIndexRoute,
  }

const AuthenticatedGetStartedGetStartedRouteWithChildren =
  AuthenticatedGetStartedGetStartedRoute._addFileChildren(
    AuthenticatedGetStartedGetStartedRouteChildren,
  )

interface AuthenticatedLocationsIdShellAiVisibilityRouteChildren {
  AuthenticatedLocationsIdShellAiVisibilityIndexRoute: typeof AuthenticatedLocationsIdShellAiVisibilityIndexRoute
  AuthenticatedLocationsIdShellAiVisibilitySettingsIndexRoute: typeof AuthenticatedLocationsIdShellAiVisibilitySettingsIndexRoute
}

const AuthenticatedLocationsIdShellAiVisibilityRouteChildren: AuthenticatedLocationsIdShellAiVisibilityRouteChildren =
  {
    AuthenticatedLocationsIdShellAiVisibilityIndexRoute:
      AuthenticatedLocationsIdShellAiVisibilityIndexRoute,
    AuthenticatedLocationsIdShellAiVisibilitySettingsIndexRoute:
      AuthenticatedLocationsIdShellAiVisibilitySettingsIndexRoute,
  }

const AuthenticatedLocationsIdShellAiVisibilityRouteWithChildren =
  AuthenticatedLocationsIdShellAiVisibilityRoute._addFileChildren(
    AuthenticatedLocationsIdShellAiVisibilityRouteChildren,
  )

interface AuthenticatedLocationsIdShellLabsRouteChildren {
  AuthenticatedLocationsIdShellLabsLabIdRoute: typeof AuthenticatedLocationsIdShellLabsLabIdRoute
  AuthenticatedLocationsIdShellLabsIndexRoute: typeof AuthenticatedLocationsIdShellLabsIndexRoute
}

const AuthenticatedLocationsIdShellLabsRouteChildren: AuthenticatedLocationsIdShellLabsRouteChildren =
  {
    AuthenticatedLocationsIdShellLabsLabIdRoute:
      AuthenticatedLocationsIdShellLabsLabIdRoute,
    AuthenticatedLocationsIdShellLabsIndexRoute:
      AuthenticatedLocationsIdShellLabsIndexRoute,
  }

const AuthenticatedLocationsIdShellLabsRouteWithChildren =
  AuthenticatedLocationsIdShellLabsRoute._addFileChildren(
    AuthenticatedLocationsIdShellLabsRouteChildren,
  )

interface AuthenticatedLocationsIdShellLsgRouteChildren {
  AuthenticatedLocationsIdShellLsgSettingsRoute: typeof AuthenticatedLocationsIdShellLsgSettingsRoute
  AuthenticatedLocationsIdShellLsgIndexRoute: typeof AuthenticatedLocationsIdShellLsgIndexRoute
}

const AuthenticatedLocationsIdShellLsgRouteChildren: AuthenticatedLocationsIdShellLsgRouteChildren =
  {
    AuthenticatedLocationsIdShellLsgSettingsRoute:
      AuthenticatedLocationsIdShellLsgSettingsRoute,
    AuthenticatedLocationsIdShellLsgIndexRoute:
      AuthenticatedLocationsIdShellLsgIndexRoute,
  }

const AuthenticatedLocationsIdShellLsgRouteWithChildren =
  AuthenticatedLocationsIdShellLsgRoute._addFileChildren(
    AuthenticatedLocationsIdShellLsgRouteChildren,
  )

interface AuthenticatedLocationsIdShellReviewsManagerRouteChildren {
  AuthenticatedLocationsIdShellReviewsManagerTemplatesRoute: typeof AuthenticatedLocationsIdShellReviewsManagerTemplatesRoute
  AuthenticatedLocationsIdShellReviewsManagerIndexRoute: typeof AuthenticatedLocationsIdShellReviewsManagerIndexRoute
}

const AuthenticatedLocationsIdShellReviewsManagerRouteChildren: AuthenticatedLocationsIdShellReviewsManagerRouteChildren =
  {
    AuthenticatedLocationsIdShellReviewsManagerTemplatesRoute:
      AuthenticatedLocationsIdShellReviewsManagerTemplatesRoute,
    AuthenticatedLocationsIdShellReviewsManagerIndexRoute:
      AuthenticatedLocationsIdShellReviewsManagerIndexRoute,
  }

const AuthenticatedLocationsIdShellReviewsManagerRouteWithChildren =
  AuthenticatedLocationsIdShellReviewsManagerRoute._addFileChildren(
    AuthenticatedLocationsIdShellReviewsManagerRouteChildren,
  )

interface AuthenticatedLocationsIdShellRouteChildren {
  AuthenticatedLocationsIdShellAiVisibilityRoute: typeof AuthenticatedLocationsIdShellAiVisibilityRouteWithChildren
  AuthenticatedLocationsIdShellLabsRoute: typeof AuthenticatedLocationsIdShellLabsRouteWithChildren
  AuthenticatedLocationsIdShellLrtRoute: typeof AuthenticatedLocationsIdShellLrtRoute
  AuthenticatedLocationsIdShellLsgRoute: typeof AuthenticatedLocationsIdShellLsgRouteWithChildren
  AuthenticatedLocationsIdShellSummaryRoute: typeof AuthenticatedLocationsIdShellSummaryRoute
  AuthenticatedLocationsIdShellGbpInsightsRoute: typeof AuthenticatedLocationsIdShellGbpInsightsRoute
  AuthenticatedLocationsIdShellReviewsManagerRoute: typeof AuthenticatedLocationsIdShellReviewsManagerRouteWithChildren
  AuthenticatedLocationsIdShellReviewsTrackerRoute: typeof AuthenticatedLocationsIdShellReviewsTrackerRoute
}

const AuthenticatedLocationsIdShellRouteChildren: AuthenticatedLocationsIdShellRouteChildren =
  {
    AuthenticatedLocationsIdShellAiVisibilityRoute:
      AuthenticatedLocationsIdShellAiVisibilityRouteWithChildren,
    AuthenticatedLocationsIdShellLabsRoute:
      AuthenticatedLocationsIdShellLabsRouteWithChildren,
    AuthenticatedLocationsIdShellLrtRoute:
      AuthenticatedLocationsIdShellLrtRoute,
    AuthenticatedLocationsIdShellLsgRoute:
      AuthenticatedLocationsIdShellLsgRouteWithChildren,
    AuthenticatedLocationsIdShellSummaryRoute:
      AuthenticatedLocationsIdShellSummaryRoute,
    AuthenticatedLocationsIdShellGbpInsightsRoute:
      AuthenticatedLocationsIdShellGbpInsightsRoute,
    AuthenticatedLocationsIdShellReviewsManagerRoute:
      AuthenticatedLocationsIdShellReviewsManagerRouteWithChildren,
    AuthenticatedLocationsIdShellReviewsTrackerRoute:
      AuthenticatedLocationsIdShellReviewsTrackerRoute,
  }

const AuthenticatedLocationsIdShellRouteWithChildren =
  AuthenticatedLocationsIdShellRoute._addFileChildren(
    AuthenticatedLocationsIdShellRouteChildren,
  )

interface AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRouteChildren {
  AuthenticatedLocationsIdCbCampaignCampaignIdEditEditStepRoute: typeof AuthenticatedLocationsIdCbCampaignCampaignIdEditEditStepRoute
  AuthenticatedLocationsIdCbCampaignCampaignIdEditEditIndexRoute: typeof AuthenticatedLocationsIdCbCampaignCampaignIdEditEditIndexRoute
}

const AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRouteChildren: AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRouteChildren =
  {
    AuthenticatedLocationsIdCbCampaignCampaignIdEditEditStepRoute:
      AuthenticatedLocationsIdCbCampaignCampaignIdEditEditStepRoute,
    AuthenticatedLocationsIdCbCampaignCampaignIdEditEditIndexRoute:
      AuthenticatedLocationsIdCbCampaignCampaignIdEditEditIndexRoute,
  }

const AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRouteWithChildren =
  AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRoute._addFileChildren(
    AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRouteChildren,
  )

interface AuthenticatedLocationsIdRouteChildren {
  AuthenticatedLocationsIdShellRoute: typeof AuthenticatedLocationsIdShellRouteWithChildren
  AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRoute: typeof AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRouteWithChildren
}

const AuthenticatedLocationsIdRouteChildren: AuthenticatedLocationsIdRouteChildren =
  {
    AuthenticatedLocationsIdShellRoute:
      AuthenticatedLocationsIdShellRouteWithChildren,
    AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRoute:
      AuthenticatedLocationsIdCbCampaignCampaignIdEditEditRouteWithChildren,
  }

const AuthenticatedLocationsIdRouteWithChildren =
  AuthenticatedLocationsIdRoute._addFileChildren(
    AuthenticatedLocationsIdRouteChildren,
  )

interface AuthenticatedLocationsShellRouteChildren {
  AuthenticatedLocationsShellIndexRoute: typeof AuthenticatedLocationsShellIndexRoute
}

const AuthenticatedLocationsShellRouteChildren: AuthenticatedLocationsShellRouteChildren =
  {
    AuthenticatedLocationsShellIndexRoute:
      AuthenticatedLocationsShellIndexRoute,
  }

const AuthenticatedLocationsShellRouteWithChildren =
  AuthenticatedLocationsShellRoute._addFileChildren(
    AuthenticatedLocationsShellRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRouteWithChildren
  AuthenticatedGetStartedGetStartedRoute: typeof AuthenticatedGetStartedGetStartedRouteWithChildren
  AuthenticatedLocationsIdRoute: typeof AuthenticatedLocationsIdRouteWithChildren
  AuthenticatedLocationsShellRoute: typeof AuthenticatedLocationsShellRouteWithChildren
  AuthenticatedLocationsAddIndexRoute: typeof AuthenticatedLocationsAddIndexRoute
  AuthenticatedLocationsAddKeywordsIndexRoute: typeof AuthenticatedLocationsAddKeywordsIndexRoute
  AuthenticatedLocationsAddPromptsIndexRoute: typeof AuthenticatedLocationsAddPromptsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRouteWithChildren,
  AuthenticatedGetStartedGetStartedRoute:
    AuthenticatedGetStartedGetStartedRouteWithChildren,
  AuthenticatedLocationsIdRoute: AuthenticatedLocationsIdRouteWithChildren,
  AuthenticatedLocationsShellRoute:
    AuthenticatedLocationsShellRouteWithChildren,
  AuthenticatedLocationsAddIndexRoute: AuthenticatedLocationsAddIndexRoute,
  AuthenticatedLocationsAddKeywordsIndexRoute:
    AuthenticatedLocationsAddKeywordsIndexRoute,
  AuthenticatedLocationsAddPromptsIndexRoute:
    AuthenticatedLocationsAddPromptsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface AuthAuthRouteChildren {
  AuthAuthIndexRoute: typeof AuthAuthIndexRoute
  AuthAuthForgotPasswordIndexRoute: typeof AuthAuthForgotPasswordIndexRoute
  AuthAuthLoginIndexRoute: typeof AuthAuthLoginIndexRoute
  AuthAuthResetPasswordIndexRoute: typeof AuthAuthResetPasswordIndexRoute
  AuthAuthVerifyEmailIndexRoute: typeof AuthAuthVerifyEmailIndexRoute
}

const AuthAuthRouteChildren: AuthAuthRouteChildren = {
  AuthAuthIndexRoute: AuthAuthIndexRoute,
  AuthAuthForgotPasswordIndexRoute: AuthAuthForgotPasswordIndexRoute,
  AuthAuthLoginIndexRoute: AuthAuthLoginIndexRoute,
  AuthAuthResetPasswordIndexRoute: AuthAuthResetPasswordIndexRoute,
  AuthAuthVerifyEmailIndexRoute: AuthAuthVerifyEmailIndexRoute,
}

const AuthAuthRouteWithChildren = AuthAuthRoute._addFileChildren(
  AuthAuthRouteChildren,
)

interface AuthSignUpRouteChildren {
  AuthSignUpIdRoute: typeof AuthSignUpIdRoute
  AuthSignUpIndexRoute: typeof AuthSignUpIndexRoute
}

const AuthSignUpRouteChildren: AuthSignUpRouteChildren = {
  AuthSignUpIdRoute: AuthSignUpIdRoute,
  AuthSignUpIndexRoute: AuthSignUpIndexRoute,
}

const AuthSignUpRouteWithChildren = AuthSignUpRoute._addFileChildren(
  AuthSignUpRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthAuthRoute: AuthAuthRouteWithChildren,
  AuthSignUpRoute: AuthSignUpRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
